import { Badge } from '@shared/components/ui/badge';
import { usePageNavigation } from '@shared/components/navigation/usePageNavigation';
import { useTranslation } from 'react-i18next';
import type { Batch } from '../../../models/Batch';

const STATUS_STYLES: Record<string, { bg: string; text: string }> = {
  active: { bg: 'bg-bg-success', text: 'text-success' },
  expired: { bg: 'bg-bg-error', text: 'text-error' },
  depleted: { bg: 'bg-card-border light:bg-bg-warning', text: 'text-warning' },
  blocked: { bg: 'bg-card-border light:bg-bg-info', text: 'text-info' },
};

const getBatchStatus = (batch: Batch): string => {
  if (batch.blocked_at && !batch.unblocked_at) return 'blocked';
  if (batch.expiry_date && new Date(batch.expiry_date) < new Date()) return 'expired';
  if (batch.total_stock === 0) return 'depleted';
  return 'active';
};

interface BreadcrumbProps {
  batch: Batch;
}

export const Breadcrumb = ({ batch }: BreadcrumbProps) => {
  const { t } = useTranslation('batchesModule');
  const status = getBatchStatus(batch);
  const styles = STATUS_STYLES[status] || STATUS_STYLES.active;

  const breadcrumbs = [
    { label: t('detail.back'), path: '/batches' },
    {
      label: (
        <div className="flex items-center gap-2">
          <span className="text-title font-semibold">{batch.batch_number}</span>
          <Badge className={`text-xs ${styles.bg} ${styles.text}`}>{t(`status.${status}`)}</Badge>
        </div>
      ),
    },
  ];

  usePageNavigation({ breadcrumbs });
  return null;
};
